// @helpers
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { getPersonTypeAndCodeHashed } = require('utilities/hash');
const getCallbackUrl = require('../../utilities/aggregator/getCallbackUrl');

// @constant
const {
    AGGREGATOR_CONSENTS_PSD2_INIT,
    AGGREGATOR_CONSENTS_PSD2_GET_URL_REQUEST,
    AGGREGATOR_CONSENTS_PSD2_GET_URL_SUCCESS,
    AGGREGATOR_CONSENTS_PSD2_GET_URL_FAILURE,
    AGGREGATOR_CONSENTS_PSD2_GET_INFO_REQUEST,
    AGGREGATOR_CONSENTS_PSD2_GET_INFO_SUCCESS,
    AGGREGATOR_CONSENTS_PSD2_GET_INFO_FAILURE,
} = require('constants/actionTypes');

const initStoreConsentsPSD2 = () => ({
    type: AGGREGATOR_CONSENTS_PSD2_INIT,
})

const getIsUrlFetching = isFetchingUrl => ({
    type: AGGREGATOR_CONSENTS_PSD2_GET_URL_REQUEST,
    payload: isFetchingUrl,
})

const getUrlSuccess = (response) => ({
    type: AGGREGATOR_CONSENTS_PSD2_GET_URL_SUCCESS,
    payload: response
})

const getUrlFailure = (error) => ({
    type: AGGREGATOR_CONSENTS_PSD2_GET_URL_FAILURE,
    payload: error
})

const requestConsentsUrl = (userBankId) => (dispatch) => {
    const url = apiURLBuilder.getURL('aggregatorPSD2GetConsentsUrl',{userId: getPersonTypeAndCodeHashed(), userBankId: userBankId});
    dispatch(getIsUrlFetching(true))

    const callbackOkURL = getCallbackUrl(window.__ENV__, 'myprofile/global/entities/consent/ok')
    const callbackKoURL = getCallbackUrl(window.__ENV__, 'myprofile/global/entities/consent/ko')

    const requestData = {
        query: {
            userbankId: userBankId,
            scaCallbackUri: callbackOkURL,
            scaKoCallbackUri: callbackKoURL
          }
    }

    return APIPost(dispatch, url, requestData).then(
        response => {
            dispatch(getUrlSuccess(response))
            dispatch(getIsUrlFetching(false))
        },
        error => {
            dispatch(getUrlFailure(error))
            dispatch(getIsUrlFetching(false))
        }
    );
}

const getConsentInfoFetching = isFetchingConsent => ({
    type: AGGREGATOR_CONSENTS_PSD2_GET_INFO_REQUEST,
    payload: isFetchingConsent,
})

const getConsentInfoSuccess = (response) => ({
    type: AGGREGATOR_CONSENTS_PSD2_GET_INFO_SUCCESS,
    payload: response,
})

const getConsentInfoFailure = (error) => ({
    type: AGGREGATOR_CONSENTS_PSD2_GET_INFO_FAILURE,
    payload: error
})

const getConsentInfo = (userBankId, consentId) => (dispatch) => {
    const url = apiURLBuilder.getURL('aggregatorPSD2GetConsentInfo', {userId: getPersonTypeAndCodeHashed(), userBankId, consentId});
    dispatch(getConsentInfoFetching(true))
    return APIGet(dispatch, url).then(
        response => {
            dispatch(getConsentInfoSuccess(response.consent.access.accountsAccreditations.accounts))
            dispatch(getConsentInfoFetching(false))
        },
        error => {
            dispatch(getConsentInfoFailure(error))
            dispatch(getConsentInfoFetching(false))
        }
    );
}

export { requestConsentsUrl, getConsentInfo, initStoreConsentsPSD2 };